import React, { Component } from "react";
import { PostData } from "../api/service";
import { Result, Descriptions, Tag, Button } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../Helper/GlobalConstants";

class CertificateStatusPage extends Component {
  state = {
    step: 0, // 0 = email, 1 = otp, 2 = list
    email: "",
    otp: "",
    isSubmitting: false,
    list: [],
    status_text: "",
    recaptcha_token: "",
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSendOtp = (e) => {
    if (e) e.preventDefault();

    if (this.state.email.trim() === "") {
      return;
    }

    if (this.state.recaptcha_token === "") {
      alert("Please verify that you are not a robot.");
      return;
    }

    this.setState({ isSubmitting: true });

    PostData(`/certificate-status/send-otp`, {
      email: this.state.email.trim(),
      recaptcha_token: this.state.recaptcha_token,
    })
      .then((resp) => {
        if (resp.status === true) {
          this.setState({
            step: 1,
            status_text: resp.status_text,
            isSubmitting: false,
            recaptcha_token: "",
          });
        } else {
          // reCAPTCHA token is single-use; force re-verify on retry
          this.setState({ isSubmitting: false, recaptcha_token: "" });
          alert(resp.status_text);
        }
      })
      .catch(() => {
        this.setState({ isSubmitting: false, recaptcha_token: "" });
      });
  };

  handleVerifyOtp = (e) => {
    if (e) e.preventDefault();

    if (this.state.otp.trim() === "") {
      return;
    }

    this.setState({ isSubmitting: true });

    PostData(`/certificate-status/verify-otp`, {
      email: this.state.email.trim(),
      otp: this.state.otp.trim(),
    })
      .then((resp) => {
        if (resp.status === true) {
          this.setState({
            step: 2,
            list: resp.data || [],
            isSubmitting: false,
          });
        } else {
          this.setState({ isSubmitting: false });
          alert(resp.status_text);
        }
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
      });
  };

  getTagColor = (item) => {
    if (item.is_printable) {
      return "green";
    }
    if (
      item.stage_label &&
      (item.stage_label.indexOf("Cancelled") === 0 ||
        item.stage_label.indexOf("Rejected") === 0)
    ) {
      return "red";
    }
    if (item.stage_label === "Payment pending") {
      return "orange";
    }
    return "blue";
  };

  renderHeader = () => (
    <h3
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div style={{ marginLeft: 0, fontWeight: 700 }}>
        Check Certificate Status
        <br />
        <div style={{ fontSize: 16 }}>
          Rangia College, Rangia, Kamrup(R), Assam (India) Pin 781354
        </div>
      </div>
    </h3>
  );

  renderEmailStep = () => (
    <div className="form-contents">
      {this.renderHeader()}
      <hr />
      <h6>** Enter the email ID you used while applying for the certificate</h6>
      <hr />
      <form className="form" onSubmit={this.handleSendOtp}>
        <div className="row">
          <div className="col-md-10">
            <input
              className="form-control input-sm"
              placeholder="Enter your email ID"
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.onChange}
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-sm btn-primary"
              type="submit"
              disabled={this.state.isSubmitting}
              style={{ backgroundColor: "#1f2a55" }}
            >
              {this.state.isSubmitting ? "Sending..." : "Send OTP"}
            </button>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-12">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={(token) =>
                this.setState({ recaptcha_token: token || "" })
              }
              onExpired={() => this.setState({ recaptcha_token: "" })}
            />
          </div>
        </div>
      </form>
    </div>
  );

  renderOtpStep = () => (
    <div className="form-contents">
      {this.renderHeader()}
      <hr />
      <h6>** {this.state.status_text}</h6>
      <hr />
      <form className="form" onSubmit={this.handleVerifyOtp}>
        <div className="row">
          <div className="col-md-10">
            <input
              className="form-control input-sm"
              placeholder="Enter the 6-digit OTP"
              name="otp"
              maxLength={6}
              value={this.state.otp}
              onChange={this.onChange}
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-sm btn-primary"
              type="submit"
              disabled={this.state.isSubmitting}
              style={{ backgroundColor: "#1f2a55" }}
            >
              {this.state.isSubmitting ? "Verifying..." : "Verify"}
            </button>
          </div>
        </div>
      </form>
      <br />
      <div style={{ fontSize: 13 }}>
        Didn't receive the OTP?{" "}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            // reCAPTCHA is single-use; go back to re-verify before resending
            this.setState({ step: 0, otp: "", recaptcha_token: "" });
          }}
        >
          Resend OTP
        </a>
      </div>
    </div>
  );

  renderList = () => {
    if (this.state.list.length === 0) {
      return (
        <div className="reg-form">
          <Result
            status="info"
            title="No certificate requests found in your name."
          />
        </div>
      );
    }

    return this.state.list.map((item) => (
      <div className="reg-form" key={item.id} style={{ marginBottom: 20 }}>
        <div className="form-contents">
          <h4 style={{ fontWeight: 700, marginBottom: 12 }}>
            {item.type_name}{" "}
            <Tag color={this.getTagColor(item)}>{item.stage_label}</Tag>
          </h4>
          <Descriptions column={1} bordered={true} size="small">
            <Descriptions.Item label="Request No">
              #{item.id}
            </Descriptions.Item>
            <Descriptions.Item label="Certificate Type">
              {item.type_name}
              {item.type_code ? " (" + item.type_code + ")" : ""}
            </Descriptions.Item>
            <Descriptions.Item label="Applicant Name">
              {item.name}
            </Descriptions.Item>
            <Descriptions.Item label="Course">
              {item.course}
            </Descriptions.Item>
            <Descriptions.Item label="Roll No">
              {item.roll_no}
            </Descriptions.Item>
            <Descriptions.Item label="Applied On">
              {item.date_of_application}
            </Descriptions.Item>
            <Descriptions.Item label="Current Stage">
              {item.stage_label}
            </Descriptions.Item>
            <Descriptions.Item label="Last Update">
              {item.last_update}
            </Descriptions.Item>
          </Descriptions>
          {item.is_printable && (
            <div style={{ marginTop: 16 }}>
              <Button
                type="primary"
                href={"/certificate-print?certificate_no=" + item.print_code}
                style={{ backgroundColor: "#1f2a55", borderColor: "#1f2a55" }}
              >
                Print Certificate
              </Button>
            </div>
          )}
        </div>
      </div>
    ));
  };

  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          {this.state.step < 2 && (
            <div className="reg-form">
              <div className="top-bar"></div>
              {this.state.step === 0 && this.renderEmailStep()}
              {this.state.step === 1 && this.renderOtpStep()}
            </div>
          )}

          {this.state.step === 2 && (
            <React.Fragment>
              <div className="reg-form">
                <div className="top-bar"></div>
                <div className="form-contents">
                  {this.renderHeader()}
                  <hr />
                  <h6>
                    ** Showing all certificate requests for{" "}
                    <strong>{this.state.email}</strong>
                  </h6>
                </div>
              </div>
              <br />
              {this.renderList()}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default CertificateStatusPage;
